import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useLanguage } from '../../../context/LanguageContext';
import api from '../../../services/api';
import '../ChatApp.css';

export default function AiAssistantTopic({ storeId }) {
  const { t } = useLanguage();
  const [messages, setMessages] = useState([
    {
      role: 'bot',
      text: t('chatApp.aiWelcome'),
    },
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);

  const send = async () => {
    const q = input.trim();
    if (!q || loading) return;
    setInput('');
    setMessages((m) => [...m, { role: 'user', text: q }]);
    setLoading(true);
    try {
      const res = await api.chatUiAiAsk({ question: q, store_id: storeId || undefined });
      const data = res?.data ?? res;
      setMessages((m) => [...m, { role: 'bot', text: data.answer || t('chatApp.aiError') }]);
    } catch {
      setMessages((m) => [...m, { role: 'bot', text: t('chatApp.aiError') }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100" style={{ minHeight: '400px' }}>
      <div className="flex-grow-1 overflow-auto mb-2">
        {messages.map((msg, i) => (
          <div key={i} className={`chat-bubble-row ${msg.role}`}>
            <div className="chat-bubble">{msg.text}</div>
          </div>
        ))}
        {loading && (
          <div className="chat-bubble-row bot">
            <div className="chat-bubble"><Spinner size="sm" /> …</div>
          </div>
        )}
      </div>
      <div className="chat-ai-input-bar">
        <input
          className="form-control"
          placeholder={t('chatApp.aiPlaceholder')}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && send()}
        />
        <Button className="btn-gradient" onClick={send} disabled={loading}>
          {t('chatApp.send')}
        </Button>
      </div>
    </div>
  );
}

